/**
 * Date ranges, as London days. Presets end today (London), and the selected
 * range lives in the URL (?range=30d or ?from=…&to=…) so a view can be
 * bookmarked or pasted into a message and opens on the same numbers.
 */
import { addDays, daysBetween, londonDay } from '@totum-analytics/shared/dates';

export const PRESETS = [
  { id: '7d', label: '7 days', days: 7 },
  { id: '30d', label: '30 days', days: 30 },
  { id: '90d', label: '90 days', days: 90 },
] as const;

export type PresetId = (typeof PRESETS)[number]['id'];

export interface Range {
  from: string;
  to: string;
  preset: PresetId | null;
  days: number;
}

const DAY = /^\d{4}-\d{2}-\d{2}$/;

export function rangeFromParams(params: URLSearchParams, now: Date = new Date()): Range {
  const from = params.get('from');
  const to = params.get('to');
  if (from && to && DAY.test(from) && DAY.test(to) && from <= to) {
    return { from, to, preset: null, days: daysBetween(from, to) };
  }
  const preset = PRESETS.find((p) => p.id === params.get('range')) ?? PRESETS[1];
  const end = londonDay(now);
  return { from: addDays(end, -(preset.days - 1)), to: end, preset: preset.id, days: preset.days };
}

export function rangeQuery(range: Range): string {
  return `from=${range.from}&to=${range.to}`;
}
